const loadScript = (url: string, id: string) =>
	new Promise((resolve, reject) => {
		let ready = false;
		if (!document) {
			reject(new Error("Document was not defined"));
		}

		let script = document.getElementById(id) as HTMLScriptElement;
		if (script) {
			resolve(script);
			return;
		}

		const tag = document.getElementsByTagName("script")[0];
		script = document.createElement("script") as HTMLScriptElement;

		script.type = "text/javascript";
		script.id = id;
		script.src = url;
		script.async = true;
		script.defer = true;
		// @ts-ignore
		script.onreadystatechange = function() {
			if (!ready && (!this.readyState || this.readyState === "complete")) {
				ready = true;
				resolve(script);
			}
		};

		// @ts-ignore
		script.onload = script.onreadystatechange;

		script.onerror = msg => {
			console.log(msg);
			reject(new Error("Error loading script."));
		};

		script.onabort = msg => {
			console.log(msg);
			reject(new Error("Script loading aborted."));
		};

		if (tag.parentNode != null) {
			tag.parentNode.insertBefore(script, tag);
		}
	});

export default loadScript;
